import { useState } from 'react';
import api from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Mail, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

export const ChangeEmailCard = ({ user }) => {
  const [newEmail, setNewEmail] = useState('');
  const [emailPassword, setEmailPassword] = useState('');
  const [showEmailPassword, setShowEmailPassword] = useState(false);
  const [changingEmail, setChangingEmail] = useState(false);

  const handleChangeEmail = async () => {
    if (!newEmail.trim()) { toast.error('Please enter a new email address'); return; }
    if (!emailPassword) { toast.error('Please enter your current password to confirm'); return; }
    setChangingEmail(true);
    try {
      const res = await api.post('/user/email/request-change', {
        new_email: newEmail.trim(), current_password: emailPassword
      });
      toast.success(res.data.message);
      setNewEmail(''); setEmailPassword('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to request email change');
    } finally { setChangingEmail(false); }
  };

  return (
    <Card className="glass border-white/20 dark:border-white/10">
      <CardHeader>
        <CardTitle className="font-['Manrope'] flex items-center gap-2">
          <Mail className="w-5 h-5" /> Change Email
        </CardTitle>
        <CardDescription>Update your account email address. A verification link will be sent to the new address.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label>Current Email</Label>
          <p className="text-sm text-muted-foreground">{user?.email}</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="new-email">New Email Address</Label>
          <Input id="new-email" type="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} placeholder="Enter new email address" data-testid="new-email-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email-password">Current Password</Label>
          <div className="relative">
            <Input id="email-password" type={showEmailPassword ? 'text' : 'password'} value={emailPassword} onChange={(e) => setEmailPassword(e.target.value)} placeholder="Confirm with your password" data-testid="email-password-input" />
            <button type="button" onClick={() => setShowEmailPassword(!showEmailPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
              {showEmailPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
        </div>
        <Button onClick={handleChangeEmail} disabled={changingEmail || !newEmail.trim() || !emailPassword} data-testid="change-email-btn">
          {changingEmail ? 'Sending...' : 'Send Verification Email'}
        </Button>
      </CardContent>
    </Card>
  );
};
